// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__ELJq-","cardsGroup":"Cards_cardsGroup__D6AMa","cardContent":"Cards_cardContent__luaHt","cardsTitle":"Cards_cardsTitle__l76qW","icon":"Cards_icon__bEJXe"};